<template>
  <div class="bg-gradient-to-b from-limed-spruce-800/50 py-8 to-transparent min-h-24 w-full border-b border-b-white/10 p-4 flex flex-col justify-center items-center relative overflow-hidden">
    <div class="w-full sm:flex sm:justify-between grid grid-cols-[auto_1fr_1fr_1fr_1fr] justify-center items-center z-20">
      <div class="sm:hidden sm:col-span-1 col-span-full pb-8">
        <NuxtLink to="/app">
          <button class="bg-turquoise-500/20 border-turquoise-900 text-turquoise-500 shadow-xl rounded-full btn btn-circle btn-sm">
            <Icon name="mdi:arrow-left"></Icon>
          </button>
        </NuxtLink>
      </div>

      <div class="col-span-4 flex-col sm:flex-row flex justify-start items-start sm:items-center sm:space-x-2">
        <h1 class="text-lg sm:pb-0 pb-2 sm:text-xl text-turquoise-500 uppercase tracking-widest font-light">Over The Counter Marketplace</h1>
        <div class="bg-red-600 text-sm font-bold tracking-widest text-white py-0.5 px-2 rounded-md">BETA</div>
      </div>

      <OTCGuide start="buy">
        <div class="bg-white/10 rounded-md p-2 flex justify-center items-center space-x-2 shadow-xl cursor-pointer hover:scale-105 duration-300">
          <p class="text-sm uppercase tracking-widest text-turquoise-500">Guide</p>
          <button class="w-6 h-6 bg-turquoise-500/30 flex justify-center items-center rounded-full btn btn-circle min-h-0 m-0 p-0 border-none">
            <Icon class="text-turquoise-500 text-xl" name="bi:question"></Icon>
          </button>
        </div>
      </OTCGuide>
    </div>

    <!--<div class="w-full z-20">
      <div class="w-full flex justify-start items-end">
        <div class="w-full flex justify-start xl:items-center items-start space-x-4 flex-shrink-0">
          <div class="w-24 h-24 flex-shrink-0 rounded-xl bg-white/5 border border-white/20 overflow-hidden p-1">
            <img class="border rounded-md border-white/50 w-full h-full object-cover" :src="project_logo" alt="" />
          </div>

          <div class="w-full max-w-full xl:max-w-md">
            <div class="mb-2">
              <p class="text-sm text-turquoise-500 mb-2">Trending Now</p>
              <div class="flex justify-start space-x-4 items-center">
                <h6 class="text-3xl text-white">{{ project_name }}</h6>
                <NuxtLink :to="`/app/project/${project_id}`">
                  <button class="btn btn-sm text-white font-light">view</button>
                </NuxtLink>
              </div>
            </div>

            <p class="text-sm">{{ project_description }}</p>
          </div>
        </div>

        <!~~<div class="flex flex-col justify-end items-end h-full flex-shrink-0">

        <p class="pr-4 mb-4 text-white text-sm">contribution starts in</p>

        <div class="grid grid-cols-4 uppercase text-center" >

          <div class="px-4">
            01
          </div>
          <div class="px-4">
            01
          </div>
          <div class="px-4">
            01
          </div>
          <div class="px-4">
            01
          </div>

          <div class="text-xs">day</div>
          <div class="text-xs">hour</div>
          <div class="text-xs">min</div>
          <div class="text-xs">sec</div>

          
        </div>

      </div>~~>
      </div>
    </div>-->

    <!-- <div class="w-full h-full absolute">
      <img class="w-full h-full object-cover opacity-5" :src="project_banner" alt="" />
    </div> -->
  </div>
</template>

<script setup>
const props = defineProps(["project_banner", "project_name", "project_logo", "project_id", "project_description", "project_start"]);
const { project_banner, project_name, project_logo, project_id, project_description } = toRefs(props);
</script>

<style></style>
